<template>
  <div class="card-order">
    <div class="card-order__header">
      <span class="card-order__header__folio">
        {{ `${$t("planner.folio")}: ${order.folio}` }}
      </span>

      <img
        v-if="order.customer_logo != null"
        :src="order.customer_logo"
        alt="icon"
        class="card-order__header__customer_icon"
      />

      <span class="card-order__header__date">
        {{ order.created_date }}
      </span>
    </div>

    <div class="card-order__content">
      <h2 class="card-order__content__title">
        {{ order.customer }}
      </h2>
    </div>

    <div class="card-order__footer">
      <span class="card-order__footer__status">
        {{ order.is_hybrid ? 'Híbrido' : order.warehouse_name }}
      </span>
      <span v-if="order.is_urgent" class="card-order__footer__urgent">U</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CardOrder',
  props: {
    order: {
      type: Object,
      default: () => ({
        folio: '0',
        customer: 'PUBLICO GENERAL',
        customer_logo: null,
        created_date: '2025-05-07'
      })
    }
  }
}
</script>

<style lang="scss">
.card-order {
  padding: 12px;
  min-height: 150px;
  border: 1px solid #e1e1e1;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  gap: 8px;

  &__header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    &__folio {
      font-size: 1rem;
      font-weight: 500;
    }
    &__date {
      background: rgba(var(--primary), 0.25);
      border: 1px solid rgba(var(--primary), 0.5);
      font-size: 0.9rem;
      color: rgba(var(--primary), 1);
      padding: 2px 8px;
      border-radius: 12px;
    }
    &__customer_icon {
      width: 25px;
      height: 25px;
    }

  }

  &__content {
    &__title {
      font-size: 1.1rem;
      font-weight: bold;
    }
  }

  &__footer {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    &__status {
      font-size: 0.9rem;
      color: #009dff;
      text-transform: uppercase;
      font-weight: 500;
      padding: 4px 8px;
      border-radius: 12px;
      background: #009dff1a;
      border: 1px solid #009dff;
    }
    &__urgent {
      background: rgba(255, 0, 0, 0.2);
      border: 1px solid rgba(255, 0, 0, 0.5);
      font-size: 0.9rem;
      color: rgba(255, 0, 0, 1);
      padding: 2px 8px;
      border-radius: 12px;
    }
  }
}

body.dark .card-order {
  border: 1px solid #888888;
}
</style>
